import { render, staticRenderFns } from "./EditarFuncionarioAfastamentoTipo.vue?vue&type=template&id=e4ca44dc&scoped=true"
import script from "./EditarFuncionarioAfastamentoTipo.vue?vue&type=script&lang=js"
export * from "./EditarFuncionarioAfastamentoTipo.vue?vue&type=script&lang=js"
import style0 from "./EditarFuncionarioAfastamentoTipo.vue?vue&type=style&index=0&id=e4ca44dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ca44dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VCol,VRow,VSelect,VSimpleTable,VTextField})
